module.exports = "<h2 id=\"wein\">WEIN</h2>\n<p>Bitte Sehen Sie hier unsere <a href=\"/static/wine.pdf\" target=\"_blank\">Weinkarte</a> ein.\n(Jahrgangswechsel möglich.)</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/wine_de.md
// module id = 6rrY
// module chunks = 0